import {guid} from '@utils/appUtils'
import { setContext } from 'apollo-link-context'
import { ApolloLink } from 'apollo-link'
import {lockr, uiConstants, stringify} from '@api'
import * as _ from 'lodash'
import config from '../config'

class LogUtils {
  
  Logentries
  loggingMiddleware

  logErrors = ({graphQLErrors, networkError, operation}) => {
    if (config.leToken) {
      const context = operation.getContext()
      const user: any = lockr.get('user')

      let baseErrorObj = {
        'Correlation-ID': context.headers ? context.headers['X-Correlation-ID'] : null,
        'user': user ? user.username : '',
        'Operation': context.skipAuth ? 'login' : operation.operationName,
        /**
         * FIXME: Find better way to prevent logging of password
         */
        'variables': context.skipAuth || _.includes(Object.keys(operation.variables), 'password') ? {} : stringify(operation.variables)
      }

      if (graphQLErrors) {
        graphQLErrors.forEach(({message, locations, path}) => {
          console.error({
            ...baseErrorObj,
            'error': {
              message,
              location: locations,
              path
            },
            'errorType': 'graphQLError'
          })
        })
      }

      if (networkError) {
        console.error({
          ...baseErrorObj,
          'error': networkError,
          'errorType': 'networkError'
        })
      }
    }
  }

  constructor () {
    if (config.leToken) {
    }

    this.loggingMiddleware = setContext((operation, {headers}) => {
      return {
        headers: {
          ...headers,
          'X-Correlation-ID': guid()
        },
        startTime: new Date().getTime()
      }
    })
  }
}

export const logUtils = new LogUtils()


// WEBPACK FOOTER //
// ./src/utils/logUtils.ts